<template>
    <div>

        <button type="button" class="btn btn-primary" @click="openCreateTheme">
            Adicionar Tema
        </button>

        <b-modal
            id="createTheme"
            title="Adicionar Tema"
            size="lg"
            hide-footer>

            <b-tabs content-class="mt-3">

                <b-tab title="Criar um Tema" active>

                    <!-- Overview -->
                    <div class="text-center p-5">
                        <div>
                            <h2>Crie um Tema</h2>
                            <p>
                                Você pode criar um tema de redação para usar em sua escola atual. O tema poderá ser usado para criar tarefas, simulados entre outras
                                funcionalidades que precisem do tema especificamente.
                            </p>
                            <a href="/teacher/themes/create" class="btn btn-primary">
                                Criar Tema
                            </a>
                        </div>
                    </div>

                </b-tab>

                <b-tab title="Banco de Temas">

                    <!-- Overview -->
                    <div class="text-center p-5" v-if="!showThemesShared">
                        <div>
                            <h2>Banco de Temas</h2>
                            <p>
                                Você pode adicionar temas a sua organização/escola a partir do nosso banco de temas.
                                Basta escolher dentre os temas da lista e você já poderá utilizá-lo no sistema,
                                seja em tarefas, simulados ou envio de redações avulsos pelos seus alunos.
                            </p>
                            <b-button variant="primary" @click="showThemesShared = true">
                                Ver Temas Disponíveis
                            </b-button>
                        </div>
                    </div>

                    <!-- Shared Themes -->
                    <index-shared v-if="showThemesShared" :endpoint-index="endpointIndexShared" :endpoint-attach="endpointAttach" :modes="modes"></index-shared>

                </b-tab>
            </b-tabs>

        </b-modal>
    </div>
</template>

<script>
import IndexShared from "./IndexShared";

export default {
    components: {
        IndexShared
    },
    props: ['endpointIndexShared', 'endpointAttach', 'modes'],
    data() {
        return {
            showThemesShared: false,
        }
    },
    methods: {
        openCreateTheme() {
            this.$bvModal.show('createTheme')
        }
    }
}
</script>

<style scoped>

</style>
